import { Model, type ModelProps } from '@/infra/model'
import { computed, observable } from 'mobx'
import type { SupportingItemInputBase } from '../supporting-item-input'
import { toStream } from '@/utils/mobx-util'

/**
 * Props for {@link PersonalInfoSupportingItemInput}.
 */
export type PersonalInfoSupportingItemInputProps =
  ModelProps<PersonalInfoSupportingItemInput> & { type: 'PersonalInfo' }

/**
 * Supporting item input for personal information.
 */
export class PersonalInfoSupportingItemInput
  extends Model<PersonalInfoSupportingItemInput>
  implements SupportingItemInputBase
{
  /**
   * The provided personal profile, if any.
   */
  @observable.struct accessor provided: ProvidedPersonalProfile | null = null

  /**
   * Stream of changes to the provided personal profile.
   */
  readonly providedChanges$ = toStream(() => this.provided)

  /** @inheritDoc */
  @computed get isCompleted() {
    return !!this.provided
  }
}

/**
 * A provided personal profile.
 */
export interface ProvidedPersonalProfile {
  readonly profileId: string
  readonly profileVersion: number
}
